import { toCSSPixel } from '../../../utils/styles'

function TableHeaderRowActions({ width }) {
  return <div style={{ width: toCSSPixel(width) }} />
}

export default TableHeaderRowActions
